import { useRegisterContext } from "../../Contexts/RegisterContext";
import warningGeneral from "../../assets/warningGeneral.png";
import { CircularProgress, Modal } from "@mui/material";
import success from "../../assets/success.png";
import Button from "../../Components/Button";
import React from "react";

function UpdateModal() {

  const {
    navigate,
    showUpdateModal,
    updateLoadState,
    setShowUpdateModal,
    setUpdateLoadState,
    handleUpdateDetails,
  } = useRegisterContext();

  const handleLogin = () => {
    setUpdateLoadState("");
    setShowUpdateModal(false);
    navigate("/login", {replace: true});
  };

  const handleClose = () => {
    setShowUpdateModal(false);
  }

  const handleBackHome = () => {
    setUpdateLoadState("");
    setShowUpdateModal(false);
    navigate("/", {replace: true});
  }

  let content = (
    <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
      <div className="flex justify-center mb-3">
        <img src={warningGeneral} alt="error icon" width="60px" />
      </div>
      <p className="text-center text-xl font-semibold mb-4">
        Registration Error
      </p>
      <p className="text-[#60656D] text-center mb-4">
        It looks like your details are already registered with us.
        Do you wish to update this instead?
      </p>
      <div className="flex">
        <Button
          className={`w-full bg-white border ${
            updateLoadState === "update" ? "text-[#757575]" : "text-black"
          }`}
          onClick={handleClose}
          disabled={updateLoadState === "update"}
        >
          Cancel
        </Button>
        <Button
          className={`w-full text-white ml-2 ${
            updateLoadState === "update" ? "bg-[#F6F7F7]" : "bg-[#0947AB]"
          }`}
          onClick={handleUpdateDetails}
          disabled={updateLoadState === "update"}
        >
          {updateLoadState === "update" ? <CircularProgress size={"1rem"} /> : "Update"}
        </Button>
      </div>
    </div>
  );

  if(updateLoadState === "success"){
    content = (
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex justify-center mb-3">
          <img src={success} alt="success icon" width="60px" />
        </div>
        <p className="text-center text-xl font-semibold mb-4">
          Update Successful
        </p>
        <p className="text-[#60656D] text-center mb-4">
          Success! Your details have been successfully updated.
        </p>
        <Button className="w-full text-white" onClick={handleLogin}>
          Login
        </Button>
      </div>
    );
  }else if(updateLoadState === "failed"){
    content = (
      <div className="sm:w-89.5 w-72 bg-white m-auto rounded-2xl p-6">
        <div className="flex justify-center mb-3">
          <img src={warningGeneral} alt="error icon" width="60px" />
        </div>
        <p className="text-center text-xl font-semibold mb-4">
          Update Failed
        </p>
        <p className="text-[#60656D] text-center mb-4">
          We're sorry, but we were unable to update your details at this time.
          Please try again later.
        </p>
        <Button className="w-full bg-white border text-black" onClick={handleBackHome}>
          Close
        </Button>
      </div>
    );
  }

  return (
    <Modal
      open={showUpdateModal}
      sx={{ display: "flex", overflow: "auto", backdropFilter: "blur(8px)" }}
    >
      {content}
    </Modal>
  );
}

export default UpdateModal;